import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue";
import _imports_0 from '@/assets/no-data/table-empty.png';
const _hoisted_1 = {
  class: "case-page common-page"
};
const _hoisted_2 = {
  class: "search"
};
const _hoisted_3 = {
  class: "case-table"
};
import { getCaseCategoryListApi, getDoctorDepListApi, getDoctorListApi, getCaseListApi, addCaseApi, deleteCaseApi } from '@/service/modules/case';
import { reactive, ref, nextTick, markRaw } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { addLoading } from '@/utils/element-method';
import { ElMessage, ElMessageBox } from 'element-plus';
import { QuestionFilled } from '@element-plus/icons-vue';
import { localCache } from '@/utils/cache';
export default /*@__PURE__*/_defineComponent({
  __name: 'case',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const form = reactive({
      dept_id: null,
      cate_id: null,
      doctor_id: null
    });
    const page = reactive({
      page: 1,
      pageSize: 15
    });
    const doctorPage = reactive({
      page: 1,
      pageSize: 500
    });
    const loadFirst = ref(true);
    const doctorDepList = ref([]);
    const categoryList = ref([]);
    const allDoctorList = ref([]);
    const doctorList = ref([]);
    const caseList = ref([]);
    const cateMap = ref({});
    const total = ref(0);
    const imageViewerList = ref([]);
    const imageViewerShow = ref(false);
    init();
    async function init() {
      await getDoctorList();
      await getDoctorDepList();
      getCaseList();
    }
    // 案例列表
    async function getCaseList() {
      let params = {
        ...page,
        ...form
      };
      const loadingInstance = addLoading('.case-table');
      try {
        let res = await getCaseListApi(params);
        caseList.value = res.data.data;
        total.value = res.data.total;
        if (loadFirst.value) loadFirst.value = false;
      } catch {} finally {
        loadingInstance.close();
      }
    }
    function restCaseList() {
      page.page = 1;
      getCaseList();
    }
    function handleClearCaseList() {
      form.cate_id = null;
      form.dept_id = null;
      form.doctor_id = null;
      restCaseList();
    }
    function handleCaseTableCurrentChange(val) {
      page.page = val;
      getCaseList();
    }
    async function handleChangeCaseStatus(item) {
      let params = {
        id: item.id,
        status: item.status
      };
      try {
        await addCaseApi(params);
        ElMessage.success('操作成功');
        restCaseList();
      } catch {}
    }
    function handleDeleteCase(id) {
      ElMessageBox.confirm('此操作将永久删除该数据, 是否继续？', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        icon: markRaw(QuestionFilled)
      }).then(async () => {
        try {
          await deleteCaseApi(id);
          ElMessage.success('删除成功');
          restCaseList();
        } catch {}
      }).catch(() => {});
    }
    // 查看封面
    function handleShowPrevImg(img) {
      imageViewerList.value = [img];
      imageViewerShow.value = true;
    }
    function handleCloseImageViewer() {
      imageViewerList.value = [];
      imageViewerShow.value = false;
    }
    // 科室列表
    async function getDoctorDepList() {
      try {
        let res = await getDoctorDepListApi();
        doctorDepList.value = res.data;
      } catch {}
    }
    function getDeptName(id) {
      let item = doctorDepList.value.find(item => item.id == id);
      if (item) {
        return item.name;
      } else {
        return '-';
      }
    }
    // 分类
    async function getCaseCategoryList(id) {
      try {
        let res = await getCaseCategoryListApi(id);
        cateMap.value[id] = res.data;
      } catch {}
    }
    // 医生
    async function getDoctorList() {
      let params = {
        ...doctorPage,
        dept_id: form.dept_id
      };
      try {
        let res = await getDoctorListApi(params);
        doctorList.value = res.data.data;
      } catch {}
    }
    // 所有医生
    getAllDoctorList();
    async function getAllDoctorList() {
      let params = {
        ...doctorPage
      };
      try {
        let res = await getDoctorListApi(params);
        allDoctorList.value = res.data.data;
      } catch {}
    }
    function getDoctorName(id) {
      let item = allDoctorList.value.find(item => item.id == id);
      if (item) {
        return item.name;
      } else {
        return '-';
      }
    }
    function handleRouteTo(item) {
      localCache.setCache('caseInfo', item);
      router.push({
        path: '/case-store/operate',
        query: {
          case_id: item.id
        }
      });
    }
    function loadMoreDoctorList() {
      console.log('loadMoreDoctorList');
      nextTick(() => {
        const selectWarp = document.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
        console.log('selectWarp', selectWarp);
        selectWarp?.addEventListener('scroll', () => {
          console.log(111);
        }, true);
      });
    }
    function handleScroll() {
      console.log('this');
    }
    async function deptSelectChange(val) {
      form.cate_id = null;
      form.doctor_id = null;
      if (cateMap.value[val]) {
        categoryList.value = cateMap.value[val];
      } else {
        await getCaseCategoryList(val);
        categoryList.value = cateMap.value[val];
      }
      getDoctorList();
    }
    function deptSelectClear() {
      form.cate_id = null;
      form.doctor_id = null;
      categoryList.value = [];
    }
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_table = _resolveComponent("el-table");
      const _component_proto_pagination = _resolveComponent("proto-pagination");
      const _component_el_image_viewer = _resolveComponent("el-image-viewer");
      const _directive_loadMore = _resolveDirective("loadMore");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[12] || (_cache[12] = _createElementVNode("div", {
        class: "page-title"
      }, "案例管理", -1)), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_form, {
        inline: true,
        model: form,
        class: "flex"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "分类筛选"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: form.dept_id,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.dept_id = $event),
            clearable: "",
            onChange: deptSelectChange,
            onClear: deptSelectClear,
            placeholder: "请选择科室",
            style: {
              "width": "130px"
            }
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(doctorDepList.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                label: item.name,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 256))]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_select, {
            disabled: !form.dept_id,
            modelValue: form.cate_id,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.cate_id = $event),
            clearable: "",
            placeholder: "请选择分类",
            style: {
              "width": "130px",
              "margin-left": "6px"
            }
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryList.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                label: item.name,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 256))]),
            _: 1
          }, 8, ["disabled", "modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "医生"
        }, {
          default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_select, {
            disabled: !form.dept_id,
            modelValue: form.doctor_id,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.doctor_id = $event),
            onFocus: loadMoreDoctorList,
            placeholder: "请选择医生",
            clearable: ""
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(doctorList.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                label: item.name,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 256))]),
            _: 1
          }, 8, ["disabled", "modelValue"])), [[_directive_loadMore, loadMoreDoctorList]])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            onClick: _cache[3] || (_cache[3] = $event => handleClearCaseList())
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("重置")])),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            onClick: restCaseList
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("搜索")])),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          style: {
            "margin-left": "auto"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[4] || (_cache[4] = $event => _unref(router).push({
              path: '/case-store/operate'
            }))
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("上传案例")])),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])]), _createElementVNode("div", _hoisted_3, [!loadFirst.value ? (_openBlock(), _createBlock(_component_el_table, {
        key: 0,
        data: caseList.value,
        "header-cell-style": {
          background: '#F7F9FB !important',
          color: '#111111',
          height: '42px',
          fontSize: '14px'
        }
      }, {
        empty: _withCtx(() => _cache[11] || (_cache[11] = [_createElementVNode("div", {
          class: "table-empty"
        }, [_createElementVNode("img", {
          class: "no-data",
          src: _imports_0,
          alt: ""
        }), _createElementVNode("div", {
          class: "empty-text"
        }, "暂无数据")], -1)])),
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "序号",
          width: "70"
        }, {
          default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.$index + 1 + (page.page - 1) * page.pageSize), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "封面"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_link, {
            type: "primary",
            onClick: $event => handleShowPrevImg(scope.row.thumb)
          }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("查看")])),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "resource_num",
          label: "数量"
        }), _createVNode(_component_el_table_column, {
          label: "分类",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(scope => [_createTextVNode(_toDisplayString(getDeptName(scope.row.dept_id)) + "/" + _toDisplayString(scope.row?.category?.name), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "医生",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(scope => [_createTextVNode(_toDisplayString(getDoctorName(scope.row.doctor_id)), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "状态",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_switch, {
            modelValue: scope.row.status,
            "onUpdate:modelValue": $event => scope.row.status = $event,
            "inactive-value": 0,
            "active-value": 1,
            onChange: $event => handleChangeCaseStatus(scope.row)
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "ct_time",
          label: "上传时间"
        }), _createVNode(_component_el_table_column, {
          label: "操作"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_link, {
            type: "primary",
            style: {
              "margin-right": "10px"
            },
            onClick: $event => handleRouteTo(scope.row)
          }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("编辑")])),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_link, {
            type: "danger",
            onClick: $event => handleDeleteCase(scope.row.id)
          }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode("删除")])),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])) : _createCommentVNode("", true), _createVNode(_component_proto_pagination, {
        page: page,
        total: total.value,
        onCurrentChange: handleCaseTableCurrentChange
      }, null, 8, ["page", "total"])]), imageViewerShow.value ? (_openBlock(), _createBlock(_component_el_image_viewer, {
        key: 0,
        teleported: true,
        "url-list": imageViewerList.value,
        onClose: handleCloseImageViewer
      }, null, 8, ["url-list"])) : _createCommentVNode("", true)]);
    };
  }
});